module.exports = __webpack_public_path__ + "img/CICADA-logo-almost-black.f530753.svg";